import ColorPickerField from './ColorPickerField.component';

export default ColorPickerField;
